import { useGames } from '@/api/games';
import { useDebounce } from '@starsoft/common/hooks';
import { RootState } from '@/lib/store';
import { useDispatch, useSelector } from 'react-redux';
import styles from './styles.module.scss';
import { AnimatePresence } from 'framer-motion';
import { setModalSearch, toggleSearch } from '@/lib/store/casino/actions';

import GameSearchModalContent from './Content';
import GameSearchInput from '../Input';
import GameSearchModalHeader from './GamesResult/Header';
import { useInfiniteScroll } from '@starsoft/common/hooks';
import SearchModal from '@/components/core/InputSearch/Modal';

export default function GameSearchModal() {
  const open: boolean = useSelector(
    (state: RootState) => state.casino.openSearch,
  );
  const search: string = useSelector(
    (state: RootState) => state.casino.modalSearch,
  );
  const debouncedSearch = useDebounce(search);
  const dispatch = useDispatch();

  const {
    hasNextPage,
    isFetching,
    isLoading,
    isFetchingNextPage,
    fetchNextPage,
    games,
    error,
    refetch,
    metadata,
    isSuccess,
  } = useGames({
    query: debouncedSearch,
    enabled: open && debouncedSearch?.length >= 3,
  });
  const { ref } = useInfiniteScroll({
    hasMore: hasNextPage ?? false,
    isLoading: isLoading || isFetchingNextPage || isFetching,
    loadMore: () => fetchNextPage(),
  });

  function handleToggleModal() {
    dispatch(toggleSearch());
    dispatch(setModalSearch(''));
  }

  return (
    <AnimatePresence>
      {open && (
        <SearchModal onClose={handleToggleModal}>
          <div className={styles['sticky-container']}>
            <GameSearchInput
              focusOnMount
              isLoading={isLoading || isFetchingNextPage}
            />

            {(debouncedSearch?.length > 3 ||
              ((games?.length ?? 0) > 0 && !error && !isLoading)) && (
              <GameSearchModalHeader
                isLoading={isLoading}
                error={error}
                currentAmount={games?.length}
                count={metadata?.count ?? 0}
              />
            )}
          </div>
          <div className={styles.content} ref={ref}>
            <GameSearchModalContent
              error={error}
              isFetchingNextPage={isFetchingNextPage}
              isLoading={isLoading}
              games={games ?? []}
              refetch={refetch}
              isSuccess={isSuccess}
              search={debouncedSearch}
            />
          </div>
        </SearchModal>
      )}
    </AnimatePresence>
  );
}
